module.exports = __webpack_public_path__ + "static/media/service-station.2f6cef13.svg";